import { useSlate } from '@tribeplatform/react-slate-kit/hooks'
import {
  LayoutBlockProps,
  SlateProps,
} from '@tribeplatform/react-slate-kit/types'

import { Post } from './Post.js'
import { PostPreview } from './PostPreview.js'

type PostPageComponentType = (
  props: LayoutBlockProps & {
    spacePath: string
    postPath: string
  },
) => JSX.Element

export const PostPage: PostPageComponentType = ({
  spacePath,
  postPath,
  containerProps,
}) => {
  const {
    mode,
    extraContext: {
      slate: { postTypeId, postTypeSlateProps },
    },
  } = useSlate<{ postTypeId?: string; postTypeSlateProps?: SlateProps }>()

  if (mode !== 'live' && postTypeId) {
    return (
      <div {...containerProps}>
        <PostPreview
          postTypeId={postTypeId}
          postTypeSlateProps={postTypeSlateProps}
        />
      </div>
    )
  }

  return (
    <div {...containerProps}>
      <Post postPath={postPath} spacePath={spacePath} />
    </div>
  )
}
